<template>
  <a-input
    v-model:value="innerValue"
    :allow-clear="field.allowClear == undefined ? true : field.allowClear"
    :autocomplete="field.autocomplete == undefined ? 'off' : field.autocomplete"
    :default-value="field.defaultValue"
    :readonly="field.disabled"
    :maxlength="field.maxlength"
    :placeholder="field.placeholder ? field.placeholder : $t('请输入') + field.label"
    :type="field.inputType ? field.inputType : 'text'"
    size="small"
    @update:value="updateValue"
  >
    <template
      v-if="field?.prefix || field?.prefixIcon"
      #prefix
    >
      <span v-if="field?.prefix">{{ field.prefix }}</span>
      <component
        v-if="field?.prefixIcon"
        :is="field?.prefixIcon"
      />
    </template>
    <template
      v-if="field?.suffix || field?.suffixIcon"
      #suffix
    >
      <span v-if="field?.suffix">{{ field.suffix }}</span>
      <component
        v-if="field?.suffixIcon"
        :is="field?.suffixIcon"
      />
    </template>
    <template
      v-if="field?.addonBefore || field?.addonBeforeIcon"
      #addonBefore
    >
      <span v-if="field?.addonBefore">{{ field.addonBefore }}</span>
      <component
        v-if="field?.addonBeforeIcon"
        :is="field?.addonBeforeIcon"
      />
    </template>
    <template
      v-if="field?.addonAfter || field?.addonAfterIcon"
      #addonAfter
    >
      <span v-if="field?.addonAfter">{{ field.addonAfter }}</span>
      <component
        v-if="field?.addonAfterIcon"
        :is="field?.addonAfterIcon"
      />
    </template>
  </a-input>
</template>
<script setup lang="ts" name="InputPro">
import { computed } from 'vue';
import { normalizeFieldExtraAddonValue, stripFieldExtraAddonValue } from '../addonValue';

const value = defineModel<string | null | undefined>('value');
const props = defineProps({
  field: {
    type: Object,
    required: true,
  },
});

const innerValue = computed({
  get: () => stripFieldExtraAddonValue(props.field, value.value) as string | null | undefined,
  set: newValue => {
    value.value = normalizeFieldExtraAddonValue(props.field, newValue) as string | null | undefined;
  },
});

const updateValue = (newValue: string) => {
  innerValue.value = newValue;
};
</script>
<style scoped lang="less">
:deep(.ant-input[readonly]) {
  background-color: #f5f5f5;
}
.ant-input-affix-wrapper-readonly {
  background-color: #f5f5f5;
}
:deep(.ant-input-affix-wrapper-readonly) {
  background-color: #f5f5f5;
}
</style>
